'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REMOVE_CONTENT = exports.EDIT_ITEM = exports.ADD_CONTENT = exports.REMOVE_PRIVATE_NOTE = exports.EDIT_PRIVATE_NOTE = exports.ADD_PRIVATE_NOTE = exports.PRIVATE_NOTES = undefined;

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

var _compose = require('./compose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PRIVATE_NOTES = exports.PRIVATE_NOTES = _constantsAnalytics2.default.CATEGORIES.PRIVATE_NOTES;
var _analyticsConstants$E = _constantsAnalytics2.default.EVENTS;
var ADD_PRIVATE_NOTE = _analyticsConstants$E.ADD_PRIVATE_NOTE,
    EDIT_PRIVATE_NOTE = _analyticsConstants$E.EDIT_PRIVATE_NOTE,
    REMOVE_PRIVATE_NOTE = _analyticsConstants$E.REMOVE_PRIVATE_NOTE;
exports.ADD_PRIVATE_NOTE = ADD_PRIVATE_NOTE;
exports.EDIT_PRIVATE_NOTE = EDIT_PRIVATE_NOTE;
exports.REMOVE_PRIVATE_NOTE = REMOVE_PRIVATE_NOTE;
var _analyticsConstants$A = _constantsAnalytics2.default.ACTIONS;
var ADD_CONTENT = _analyticsConstants$A.ADD_CONTENT,
    EDIT_ITEM = _analyticsConstants$A.EDIT_ITEM,
    REMOVE_CONTENT = _analyticsConstants$A.REMOVE_CONTENT;
exports.ADD_CONTENT = ADD_CONTENT;
exports.EDIT_ITEM = EDIT_ITEM;
exports.REMOVE_CONTENT = REMOVE_CONTENT;


function composePrivateNoteEvent(eventName, action) {
  return (0, _compose.composeEvent)(eventName, {
    gtmValue: 1,
    gtmLabel: undefined,
    gtmCategory: PRIVATE_NOTES,
    gtmAction: action
  });
}

function composeAddPrivateNoteEvent() {
  return (0, _compose.composeAnalytics)([composePrivateNoteEvent(ADD_PRIVATE_NOTE, ADD_CONTENT)]);
}

function composeEditPrivateNoteEvent() {
  return (0, _compose.composeAnalytics)([composePrivateNoteEvent(EDIT_PRIVATE_NOTE, EDIT_ITEM)]);
}

function composeRemovePrivateNoteEvent() {
  return (0, _compose.composeAnalytics)([composePrivateNoteEvent(REMOVE_PRIVATE_NOTE, REMOVE_CONTENT)]);
}

exports.default = {
  composeAddPrivateNoteEvent: composeAddPrivateNoteEvent,
  composeEditPrivateNoteEvent: composeEditPrivateNoteEvent,
  composeRemovePrivateNoteEvent: composeRemovePrivateNoteEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/privateNotesEventComposer.js
// module id = 583
// module chunks = 0 2 4 5 6 8 9 10 11